import { render, staticRenderFns } from "./SelectRef.vue?vue&type=template&id=3b32673f&scoped=true&"
import script from "./SelectRef.vue?vue&type=script&lang=js&"
export * from "./SelectRef.vue?vue&type=script&lang=js&"
import style0 from "./SelectRef.vue?vue&type=style&index=0&id=3b32673f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32673f",
  null
  
)

export default component.exports